const observer = new MutationObserver(() => {
  const reviewLinks = document.querySelectorAll('.jdgm-rev__prod-link');

  if (reviewLinks.length) {
    for (const link of reviewLinks) {
      link.removeAttribute('href');
    }
    observer.disconnect(); // Stop observing once done
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});
